<template>
  <div>
    <template v-if="loading">
      <div class="text-center">
        <v-progress-circular indeterminate></v-progress-circular>
        <p class="mt-3">{{ $t("chargement") }}</p>
      </div>
    </template>
    <template v-else>
      <div class="mb-6">
        <v-text-field outlined prepend-inner-icon="mdi-magnify" hide-details v-model="searchText" class="mb-2">
          <template v-slot:label>{{ $t("boutique.rechercherUnProduit") }}</template>
        </v-text-field>
        <v-chip-group column v-model="filterCategory" active-class="primary--text" mandatory>
          <v-chip filter class="px-5" value="all">{{ $t("boutique.toutesLesCategories") }}</v-chip>
          <v-chip filter class="px-5" v-for="categorie in categories" :value="categorie.id" :key="categorie.id">
            {{ categorie[$i18n.locale] }}
          </v-chip>
        </v-chip-group>
        <v-divider class="my-1"></v-divider>
        <v-chip-group column v-model="filterLangue" active-class="primary--text" mandatory>
          <v-chip filter class="px-5" value="all">{{ $t("boutique.toutesLesLangues") }}</v-chip>
          <v-chip filter class="px-5" v-for="langue in langues" :value="langue.id" :key="langue.id">
            {{ langue[$i18n.locale] }}
          </v-chip>
        </v-chip-group>
      </div>

      <div class="d-flex justify-space-between mb-3">
        <h1>{{ $t("boutique.produits") }} ({{ produitsFiltres.length }})</h1>
        <div class="d-flex align-center">
          <span class="mr-3 caption">{{ $t("boutique.affichage") }} :</span>
          <v-btn-toggle v-model="affichage">
            <v-btn value="ListeProduitsTable" title="Table">
              <v-icon>mdi-view-sequential</v-icon>
            </v-btn>

            <v-btn value="ListeProduitsTuiles" title="Tuiles">
              <v-icon>mdi-view-grid</v-icon>
            </v-btn>
          </v-btn-toggle>
        </div>
      </div>
      <component :is="affichage" :produits="produitsFiltres" />
    </template>
  </div>
</template>

<script>
import ListeProduitsTuiles from "@/components/boutique/ListeProduitsTuiles"
import ListeProduitsTable from "@/components/boutique/ListeProduitsTable"
import { mapGetters, mapActions } from "vuex"

export default {
  components: { ListeProduitsTuiles, ListeProduitsTable },
  data() {
    return {
      loading: false,
      searchText: "",
      filterCategory: "all",
      filterLangue: "all",
      affichage: "ListeProduitsTuiles",
      caching: {
        once: true,
        loaded: false
      }
    }
  },
  computed: {
    ...mapGetters(["produits"]),
    categories() {
      return [...new Map(this.produits.map((p) => [p.categorie.id, p.categorie])).values()]
    },
    langues() {
      return [...new Map(this.produits.filter((p) => p.langue.id).map((p) => [p.langue.id, p.langue])).values()]
    },
    produitsFiltres() {
      let filtered = this.produits.filter(
        (p) =>
          p.titre.toLowerCase().includes(this.searchText.toLowerCase()) ||
          p.categorie[this.$i18n.locale].toLowerCase().includes(this.searchText.toLowerCase())
      )
      if (this.filterCategory !== "all") {
        filtered = filtered.filter((p) => p.categorie.id === this.filterCategory)
      }
      if (this.filterLangue !== "all") {
        filtered = filtered.filter((p) => !p.langue.id || p.langue.id === this.filterLangue)
      }
      return filtered
    }
  },
  async mounted() {
    await this.fetchProduits()
    this.filterLangue = this.langues.find((l) => l.code === "fr")?.id ?? "all"
  },
  methods: {
    ...mapActions(["FETCH_PRODUITS"]),
    async fetchProduits() {
      this.loading = true
      await this.FETCH_PRODUITS()
      this.loading = false
    }
  }
}
</script>

<style>
</style>